import Vue from 'vue';
import { api } from '../../domainConfig';
import axiosInstance from '../axiosInstance';
/* eslint no-shadow: ["error", { "allow": ["state"] }] */

const domain = api.userManagementDomain;
const apiKey = api.ApiKey;


const state = {
  loggedInUser: {},
  cachedOrderData: null,
  isLoggedIn: false,
  isLoading: false,
  loadingStates: {},
  language: 'en',
};

const getters = {
  getLoggedInUser: (state) => {
    return state.loggedInUser;
  },
  getIsLoggedIn: (state) => {
    return state.isLoggedIn;
  },
  getIsLoading: (state) => {
    return state.isLoading
  },
  isRequestLoading: (state) => {
    return (requestId) => { return state.loadingStates[requestId] || false }
  },
  getLanguage: (state) => {
    return state.language
  },
  getLoadingStates: (state) => {
    return state.loadingStates
  },
}

const mutations = {
  cacheOrderData(state, data) {
    state.cachedOrderData = data;
  },
  UPDATE_LOGGEDIN_USER(state, payload) {
    state.loggedInUser = payload;
  },
  SET_IS_LOGGED_IN(state, payload) {
    state.isLoggedIn = payload;
  },
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LANGUAGE(state, payload) {
    state.language = payload
  },
  SET_LOADING_STATE(state, { requestId, isLoading }) {
    Vue.set(state.loadingStates, requestId, isLoading);
  },
  RESET_LOADING_STATES(state) {
    state.loadingStates = {};
  },
};

let refreshTokenInterval = null;

const actions = {
  async attemptLogin({ commit }, { object }) {
    try {
      const response = await axiosInstance.post(`${domain}/login_workplace`, object);
      commit('UPDATE_LOGGEDIN_USER', response.data);
      commit('SET_IS_LOGGED_IN', true)

      // await dispatch('refreshToken', this.$router)
      // Dsiable refesh token since we have problems with Cookies in safar
      // dispatch('startRefreshTokenInterval');

      return response.data
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
  startRefreshTokenInterval({ dispatch }, router) {
    if (refreshTokenInterval) clearInterval(refreshTokenInterval);

    dispatch('refreshToken', router); // initial call
    refreshTokenInterval = setInterval(() => {
      dispatch('refreshToken', router).catch((err) => {
        console.error('Token refresh failed', err);
      });
    }, 3300000); // 55minutes
  },
  stopRefreshTokenInterval() {
    if (refreshTokenInterval) clearInterval(refreshTokenInterval);
  },
  resetAllLoadingStatesToFalse({ commit, state }) {
    const updatedStates = {};
    Object.keys(state.loadingStates).forEach((key) => {
      updatedStates[key] = false;
    });
    Object.entries(updatedStates).forEach(([requestId, isLoading]) => {
      commit('SET_LOADING_STATE', { requestId, isLoading });
    });
  },
  async logoutUser({ commit, dispatch }) {
    commit('UPDATE_LOGGEDIN_USER', {});
    commit('SET_IS_LOGGED_IN', false)
    localStorage.removeItem('vuex');
    window.sessionStorage.clear();
    this.loggedInUser = null;
    dispatch('stopRefreshTokenInterval');
    await dispatch('logoutRequest');// Call the logoutRequest action to handle server-side logout
  },
  async changePasswordForUser({ commit }, { object, successCallback }) {
    const response = await axiosInstance.put(`${domain}/changePasswordFirstLogin`, object)
    commit('UPDATE_LOGGEDIN_USER', response.data)
    commit('SET_IS_LOGGED_IN', true)
    successCallback();
  },
  async refreshToken({ commit, dispatch }, router) {
    try {
      const response = await axiosInstance.post(`${domain}/refresh-token`, null, {
        headers: {
          'api-key': apiKey,
          Authorization: null,
          // withCredentials: true
        },
      })

      // Retrieve the user object from localStorage
      const user = JSON.parse(localStorage.getItem('vuex'));

      // Update the token within the 'authentication' object
      user.authentication.loggedInUser.token = response.data || null;

      // Save the updated user object back to localStorage
      localStorage.setItem('vuex', JSON.stringify(user));

      commit('UPDATE_LOGGEDIN_USER', user.authentication.loggedInUser);

      return response
    } catch (error) {
      // Dispatch logoutUser to clear the session and logged-in user state
      await dispatch('logoutUser');

      // router.push({ name: 'login' })
      router.push({ path: '/login' })
      throw new Error('Failed to refresh token', error)
    }
  },
  async logoutRequest() {
    try {
      const response = await axiosInstance.post(`${domain}/logout`, {
        headers: {
          'api-key': apiKey,
          Authorization: null,
          // withCredentials: true
        },
      })
      return response
    } catch (error) {
      throw new Error('Failed to logout', error)
    }
  },
  test({ commit }) {
    commit('SET_IS_LOGGED_IN', true);
  },
  changeLoadingtoTrue({ commit }, value) {
    commit('SET_IS_LOADING', value)
  },
  changeLanguage({ commit }, lang) {
    commit('SET_LANGUAGE', lang);
  },
  resetLoadingStates({ commit }) {
    commit('RESET_LOADING_STATES');
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
}
